module.exports = __webpack_public_path__ + "img/1.8fbb2db7.gif";